// Auth endpoints. Login is live against the backend; the rest of the domain
// (OTP, refresh, reset) gets added here as the flows are wired.

import { baseApi } from '../baseApi';
import { ROUTES } from '../routes';

export interface HandshakeDto {
  /** Locally generated public key. */
  publicKey: string;
}

export interface LoginResult {
  serverPublicKey: string;
}

export const handShakeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    handshake: build.mutation<LoginResult, HandshakeDto>({
      query: (body) => ({ ...ROUTES.handShake.startup, data: body }),
    }),
  }),
});

export const { useHandshakeMutation } = handShakeApi;
